import { render, staticRenderFns } from "./UpdateRequestList.vue?vue&type=template&id=446ea3b2&scoped=true&"
import script from "./UpdateRequestList.vue?vue&type=script&lang=ts&"
export * from "./UpdateRequestList.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateRequestList.vue?vue&type=style&index=0&id=446ea3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ea3b2",
  null
  
)

export default component.exports